export default "__VITE_ASSET__BSV6hGSJ__"